












































































import { Component, Vue, Prop } from 'vue-property-decorator';
import BookingReportAlert from './partials/BookingReportAlert.vue';
import { NEGATIVE_RULE_FLAGS } from '@/constants/questionnaire_answer';

@Component({
  components: {
    BookingReportAlert,
  },
})
export default class BookingReportRiskProfileItems extends Vue {
  @Prop() readonly index!: string;
  @Prop() readonly report!: any;

  negativeRuleFlags = NEGATIVE_RULE_FLAGS;

  getWarningFlagScore(rpi) {
    if (!rpi.question_negative_rules) {
      return 1;
    }

    const flags = rpi.question_negative_rules.map((qnr) => qnr.flag);
    return Math.max(...flags);
  }

  getWarningFlagColor(key) {
    return this.negativeRuleFlags[key].color;
  }

  getSevereConcerns(rpi) {
    return rpi.question_negative_rules.filter((qnr) => qnr.flag == '5');
  }

  getPotentialConcerns(rpi) {
    return rpi.question_negative_rules.filter((qnr) =>
      ['3', '4'].includes(qnr.flag)
    );
  }

  getComments(rpi) {
    return rpi.question_negative_rules.filter((qnr) =>
      ['1', '2'].includes(qnr.flag)
    );
  }
}
